import styled, { css } from 'styled-components'
import * as S from '../../styled'
import { AVAILABLE_BRANDS, theme } from 'styles/theme'
// import bgCloud from 'assets/svg/bg_cloud.svg'

import { getSize } from 'utils'
// import VideoPlayer from '../../../atoms/VideoPlayer'

export const Container = styled(S.Container)`
  .cloud {
    transform: rotate(-90deg);
    position: fixed;
    height: 100%;
  }

  z-index: 2;

  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0fr 1fr;
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
    css`
      background-color: ${theme.colors.white};
      position: relative;
      grid-template-areas:
        'details illustration'
        'description illustration';
    `}
  ${({ theme: { color } }) =>
    color === AVAILABLE_BRANDS.CLOUD_DARK &&
    css`
      background-color: ${theme.colors.cloudPurple};
      grid-template-areas:
        'illustration details'
        'illustration description';
    `}
  .background-image {
    mask-size: ${getSize(3003)} ${getSize(3028)};
    mask-position: ${getSize(-1008)} ${getSize(-1142)};
    opacity: 1;
    z-index: -1;
  }

  @media (max-aspect-ratio: 1/1) {
    grid-template-areas:
      'illustration'
      'details'
      'description';
    grid-template-columns: 1fr;
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT &&
      css`
        grid-template-rows: ${getSize(681)} 0fr 1fr;
        padding-top: ${getSize(327)};
        .background-image {
          mask-position: ${getSize(-677)} ${getSize(-1060)};
        }
      `}
    ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_DARK &&
      css`
        grid-template-rows: ${getSize(665)} 0fr 1fr;
        .background-image {
          mask-position: ${getSize(-772)} ${getSize(-1170)};
        }
      `}
  }
`
